import { getSafePercentage } from "./sf_utils"

export const getCampaignPixelMetricValues = ({
  campaign,
  campaignAggData,
  marketplaceAggData,
  isGoalMarketplaceLead,
  pixelStats,
  conversionsCountType,
  denominator,
  conversionsRevenueType,
}) => {
  const conversionCount = pixelStats?.[conversionsCountType] || 0
  const campaignCost = isGoalMarketplaceLead
    ? parseFloat(marketplaceAggData?.lead_analytic_total_cost ?? campaign?.lead_analytic_total_cost ?? 0)
    : parseFloat(campaignAggData?.total_spend || 0)
  const revenue = pixelStats?.[conversionsRevenueType] || "0.00"

  return {
    conversionCount,
    cvr: getSafePercentage(Number(conversionCount) || 0, Number(denominator)),
    cpa: conversionCount ? campaignCost / conversionCount : "0.00",
    revenue,
    roas: campaignCost ? revenue / campaignCost : "0.00",
  }
}
